import { useSelector } from 'react-redux';

export function useIsRegisteredUser(): boolean {
	const session = useSelector((state: any) => state.session);

	const isLoggedIn = !!session?.access?.token;

	return isLoggedIn;
}
